// extracted by mini-css-extract-plugin
export default {"customButtom":"CustomButton_customButtom__X1PYX"};